import { StatsModel } from '../models/stats.model';
import { BaseSevice } from './BaseService';

class StatService extends BaseSevice {
  apiUrl = 'api/stat';

  getStats() {
    return this.request<StatsModel>(`${this.apiUrl}`, 'get').then((res) => {
      const parseHourUtc = (record?: StatsModel['year']) => {
        if (record?.hourUtc) record.hourUtc = new Date(record.hourUtc);
      };

      res.data.hourlyLast12?.forEach(parseHourUtc);
      res.data.months?.forEach(parseHourUtc);
      parseHourUtc(res.data.monthCurrent);
      parseHourUtc(res.data.monthPrevious);
      parseHourUtc(res.data.year);

      return res.data;
    });
  }
}

export const statService = new StatService();
